// chart/base_options.js
//
// Shared Chart.js styling defaults.

import merge from 'lodash.merge'
import { fontFamily } from './theme'

// Default Chart.js options applied to every chart.
const DEFAULT_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,

  plugins: {
    legend: {
      display: false,
    },

    tooltip: {
      enabled: false,
    },

    title: {
      display: true,
      text: 'Graph title',
      align: 'center',
      color: '#95999F',

      font: {
        family: fontFamily() || 'Roboto',
        size: 14,
        weight: '700',
      },

      padding: {
        bottom: 12,
      },
    },
  },

  layout: {
    padding: {
      top: 10,
      right: 10,
    },
  },

  scales: {
    x: {
      border: {
        display: true,
        width: 2,
        color: '#E9EAEB',
      },

      grid: {
        display: true,
        color: '#E9EAEB',
        lineWidth: 2,
      },

      ticks: {
        display: true,
        color: '#95999F',

        font: {
          family: fontFamily() || 'Roboto',
          size: 12,
          weight: '600',
        },
      },
    },

    y: {
      beginAtZero: true,
      max: 400,

      border: {
        display: true,
        width: 2,
        color: '#E9EAEB',
      },

      grid: {
        display: true,
        color: '#E9EAEB',
        lineWidth: 2,
      },

      ticks: {
        display: true,
        stepSize: 100,
        color: '#95999F',

        font: {
          family: fontFamily() || 'Roboto',
          size: 12,
          weight: '600',
        },
      },
    },
  },
}

export function buildBaseOptions(options = {}) {
  return merge({}, DEFAULT_OPTIONS, options)
}
